import React from 'react';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components'; // Adicionado BlockDataForm
import InlineForm from '@plone/volto/components/manage/Form/InlineForm';
import { supersetBlockSchema } from './schema';

const Edit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  const schema = supersetBlockSchema();

  // Função para lidar com mudanças no formulário
  const onChangeField = (id, value) => {
    onChangeBlock(block, {
      ...data,
      [id]: value,
    });
  };

  return (
    <>
      <div
        className={`superset-block-edit ${data.align || ''}`} // Aplica classe de alinhamento
        style={{
          padding: '2rem',
          border: '2px dashed #007bc1',
          textAlign: 'center',
          backgroundColor: '#f5f5f5',
          borderRadius: '4px',
          margin: '0 auto', // Centraliza por padrão
          maxWidth: data.align === 'full' ? '100%' : '1100px', // Lógica de largura no editor
        }}
      >
        <h3 style={{ margin: '0 0 1rem 0', color: '#007bc1' }}>📊 Bloco do Superset</h3>
        {data.dashboard_id ? (
          <p>✅ Dashboard ID configurado.<br/>Altura definida: {data.height || 800}px.</p>
        ) : (
          <p>⚠️ Por favor, cole o ID do Dashboard na barra lateral direita.</p>
        )}
      </div>

      <SidebarPortal selected={selected}>
        {/* Usamos BlockDataForm para incluir os controles de alinhamento nativos do Plone */}
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={onChangeField}
          formData={data}
          block={block} // Importante para o BlockDataForm
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;
